// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEnglish from "../locales/english.json";
import translationFrench from "../locales/french.json";
import translationArabic from "../locales/arabic.json";
import translationPortuguese from "../locales/portuguese.json";
import translationSwahili from "../locales/swahili.json";
import translationAmharic from "../locales/amharic.json";
import translationEspanish from "../locales/spanish.json";
import translationSinhala from "../locales/sinhala.json";
import translationTokPisin from "../locales/tok-pisin.json";
import translationKikingo from "../locales/kikingo.json";
import translationBahasa from "../locales/bahasa.json";
import translationKhmer from "../locales/khmer.json";
import translationRussian from "../locales/russian.json";
import translationOromo from "../locales/oromo.json";
import translationShona from "../locales/shona.json";
import translationTamil from "../locales/tamil.json";
// import { getFunFact } from "../services/home";

// const data = await getFunFact().then((data) => {
//     return data;
// });

// let totalFacts = 0;
// data.data.forEach((element, i) => {
//     totalFacts = totalFacts + 1;
//     translationEN = { ...translationEN, [`fun_fact_${i + 1}`]: element.english };
//     translationFR = { ...translationFR, [`fun_fact_${i + 1}`]: element.french };
//     translationAR = { ...translationAR, [`fun_fact_${i + 1}`]: element.arabic };
//     translationPG = { ...translationPG, [`fun_fact_${i + 1}`]: element.portuguese };
//     translationSWC = { ...translationSWC, [`fun_fact_${i + 1}`]: element.swahili };
//     translationAM = { ...translationAM, [`fun_fact_${i + 1}`]: element.amharic };
//     translationES = { ...translationES, [`fun_fact_${i + 1}`]: element.spanish };
//     translationSN = { ...translationSN, [`fun_fact_${i + 1}`]: element.shona };
//     translationTP = { ...translationTP, [`fun_fact_${i + 1}`]: element.tokPisin };
//     translationKG = { ...translationKG, [`fun_fact_${i + 1}`]: element.kikongo };
//     translationID = { ...translationID, [`fun_fact_${i + 1}`]: element.bahasa };
//     translationKM = { ...translationKM, [`fun_fact_${i + 1}`]: element.khmer };
//     translationRU = { ...translationRU, [`fun_fact_${i + 1}`]: element.russian };
//     translationOM = { ...translationOM, [`fun_fact_${i + 1}`]: element.oromo };
//     translationOM = { ...translationSI, [`fun_fact_${i + 1}`]: element.sinhala };
//     translationOM = { ...translationTA, [`fun_fact_${i + 1}`]: element.tamil };
// });

// localStorage.setItem("total_facts", totalFacts);

const resources = {
    0: {
        translation: translationEnglish
    },
    1: {
        translation: translationFrench
    },
    2: {
        translation: translationArabic
    },
    3: {
        translation: translationPortuguese
    },
    4: {
        translation: translationSwahili
    },
    5: {
        translation: translationAmharic
    },
    6: {
        translation: translationEspanish
    },
    7: {
        translation: translationShona
    },
    8: {
        translation: translationTokPisin
    },
    9: {
        translation: translationKikingo
    },
    10: {
        translation: translationBahasa
    },
    11: {
        translation: translationKhmer
    },
    12: {
        translation: translationRussian
    },
    13: {
        translation: translationOromo
    },
    14: {
        translation: translationSinhala
    },
    15: {
        translation: translationTamil
    }
};

i18n.use(initReactI18next).init({
    resources,
    lng: "0", // default language
    interpolation: {
        escapeValue: false // react already escapes values
    }
});

export default i18n;
